<template>
  <div class="container">
    <cdn-svg path="indigo/indigo_text_logo" class="h-54" />
    <div class="t-xl m-t1 dark-gray">Feedback Coach</div>
    <div class="m-tx6">
      <div class="f-h f-as f-w">
        <div class="f-v flexed m-rx8 left-col">
          <div class="m-tx3 t-xx bold">Give better feedback with confidence</div>
          <div class="m-tx6 t-xl fw-600">Get clear, actionable guidance powered by proven models like Spades and Diamonds, SBI, COIN, and DESC, for reviews, praise, or tough conversations.</div>
          <div class="m-tx6">
            <donut-button
              type="link"
              :href="'/feedback_coach/handoff?source=indigo_landing'"
              target="_blank"
              @click="trackButtonClick"
            >
              Improve your feedback now
            </donut-button>
          </div>

          <div class="t m-tx3 dark-gray">Free beta available for limited time.</div>
        </div>

        <div class="right-col m-tx3">
          <div class="f-v">
            <!-- Manager Message -->
            <div class="f-as m-bx4">
              <div class="bubble manager-bubble m-rx2">
                I need help giving my report feedback about missing a couple of important deadlines.
              </div>
              <div class="f-v">
                <div class="avatar avatar-xl">
                  <cdn-img path="indigo/demo_profile" />
                </div>
                <div class="t bold m-tx1 ta-c">Manager</div>
              </div>
            </div>

            <!-- Indigo Message -->
            <div class="f-as">
              <div class="f-v m-rx2">
                <div class="avatar avatar-xl">
                  <cdn-svg
                    path="indigo/indigo_logo"
                    class="w-100p h-100p"
                  />
                </div>
                <div class="t bold dark-purple m-tx1 ta-c">Indigo</div>
              </div>
              <div class="bubble indigo-bubble">
                Understood. Let’s make this constructive using the COIN model. Can you describe one specific deadline they missed and how it affected the team?
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  methods: {
    trackButtonClick() {
      if (window.donut && window.donut.track) {
        window.donut.track('Indigo Landing: Clicked Feedback Coach Button', {
          source: 'indigo_landing',
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../../assets/stylesheets/donut.scss';

.left-col {
  max-width: 415px;
}

.right-col {
  display: flex;
  justify-content: center;
  align-items: center;
  max-width: 420px;
  height: 420px;
  position: relative;
  z-index: 0;

  &::before {
    content: '';
    position: absolute;
    width: 420px;
    height: 420px;
    background-color: #FFF3E7;
    border-radius: 50%;
    z-index: -1;
    top: 0;
    left: 50%;
    transform: translateX(-50%);
  }
}

.bubble {
  padding: 24px;
  border-radius: 20px;
  font-size: 16px;
  line-height: 1.5;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
}

.manager-bubble {
  background-color: $white;
  color: $black;
  border: 1px solid $very-light-gray;
}

.indigo-bubble {
  background-color: $purple-bg; // Light purple bg
  color: $black;
  border: 1px solid $purple-border;
}
</style>
